import React from "react";
import { Form } from "react-final-form";
import { Box, Button, Typography } from "@mui/material";

import { LoadingButton } from "ui";

import { TextField } from "fond/form/fields";
import { AnyObject } from "fond/types";
import { generateUnusedName } from "fond/utils/naming";
import { required } from "fond/utils/validation";
import { Modal, useStackedNavigationContext } from "fond/widgets";

import { SetupContainer } from "../../import/modal/ImportModal/ImportModal.styles";

interface IFormData {
  Name: string;
}

interface IProps {
  /**
   * Callback function to handle the onClose of the modal
   */
  onClose(): void;
  /**
   * Optional array of existing version names to check against
   */
  versionNames?: string[];
}

const CreateScenarioModal: React.FC<IProps> = ({ onClose, versionNames }: IProps) => {
  const { open } = useStackedNavigationContext();

  let submit: (event?: Partial<Pick<React.SyntheticEvent, "preventDefault" | "stopPropagation">>) => Promise<AnyObject | undefined> | undefined;
  /**
   * Callback function for the Create button within the modal actions
   */
  const handleOnClick = (event: React.MouseEvent<EventTarget>) => {
    // Submits the React-Final-Form (which handles validation & calling onSubmit is validation passes)
    submit();
  };
  /**
   * On submit function called when the form is submitted and valid
   */
  const handleOnSubmit = async ({ Name }: IFormData) => {
    open("excludeDraw", { scenarioName: Name });
    onClose();
  };

  return (
    <Modal
      open
      header="New Scenario Version"
      data-testid="create-scenario-modal"
      content={
        <Box>
          <Form<IFormData>
            onSubmit={handleOnSubmit}
            render={({ handleSubmit }) => {
              submit = handleSubmit;
              return (
                <form onSubmit={handleSubmit}>
                  <Typography variant="body2">
                    This will create a new scenario version based on the original, with your excluded addresses applied.
                  </Typography>
                  <SetupContainer>
                    <Box width={424}>
                      <TextField
                        inputProps={{ "data-testid": "new-scenario-name-input" }}
                        autoFocus
                        name="Name"
                        defaultValue={generateUnusedName("Scenario", versionNames || [])}
                        required
                        label="Scenario Name"
                        fullWidth
                        validate={required}
                      />
                    </Box>
                  </SetupContainer>
                </form>
              );
            }}
          />
        </Box>
      }
      actions={
        <>
          <Button data-testid="create-scenario-cancel-button" color="primary" onClick={onClose} sx={{ marginRight: 1 }}>
            Cancel
          </Button>
          <LoadingButton data-testid="create-scenario-save-button" color="primary" onClick={handleOnClick}>
            Create scenario
          </LoadingButton>
        </>
      }
    />
  );
};

export default CreateScenarioModal;
